interface Tab {
  key: string
  label: string
  icon?: React.ReactNode
}

interface TabBarProps {
  tabs: Tab[]
  activeTab: string
  onTabChange: (key: string) => void
}

export default function TabBar({ tabs, activeTab, onTabChange }: TabBarProps) {
  return (
    <div className="tab-bar">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`tab-item${activeTab === tab.key ? ' active' : ''}`}
          onClick={() => onTabChange(tab.key)}
          type="button"
        >
          {tab.icon && <span className="tab-item__icon">{tab.icon}</span>}
          <span className="tab-item__label">{tab.label}</span>
        </button>
      ))}
    </div>
  )
}
